var borders_default = {
  "borderT": "vwDed",
  "borderB": "DXbo-",
  "borderL": "y35rm",
  "borderR": "w-Oyy",
  "borderColorOverride": "XJbWU"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
